"use client"

import { Suspense } from "react"
import Link from "next/link"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { Button } from "@/components/ui/components"
import CheckoutBonusProgramRegistrationClient from "@/components/checkout/confirmation/CheckoutBonusProgramRegistrationClient"

interface CheckoutConfirmationProps {
  checkoutContext: CheckoutContext
}
export default function CheckoutConfirmationClient(props: CheckoutConfirmationProps) {
  const { createdOrder } = useUbStorefrontState()

  return (
    <>
      <div className={"flex flex-col gap-2"}>
        <CheckoutBonusProgramRegistrationClient createdOrder={createdOrder} />
        <Link prefetch={false} className={"cursor-pointer"} href={"/"}>
          <Button size={"defaultNoGrow"} variant={"default"} className={"bg-primary py-0 font-normal text-white"}>
            {"Weiter Einkaufen"}
          </Button>
        </Link>

        <Suspense fallback={<div>Loading...</div>}>
          <div className={"hidden"}>{JSON.stringify(createdOrder, null, 2)}</div>
        </Suspense>
      </div>
    </>
  )
}
